import { ListItem, UnorderedList, VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import ExclusiveContainer from '../components/ExclusiveContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'

export default function N25_09_16() {
  return (
    <ExclusiveContainer institutions={['agsus']} category="FEATURE">
      <NoteContainer date={'16/09/2025'} version="20.4.3">
        <VStack w="full">
          <ModuleContainer moduleName="CITIZEN_PORTAL">
            <VStack>
              <CategoryContainer category="FEATURE">
                <Box>
                  <TaskTitle>Automação dos serviços</TaskTitle>
                  <TaskBreadcrumb>Serviços/ Perfil do Serviço / Automações</TaskBreadcrumb>
                  <UnorderedList fontSize={'sm'} color="gray.600">
                    <ListItem>Atualização de Dados Cadastrais - Saúde Indígena</ListItem>
                    <ListItem>Atualização de Dados Cadastrais - Médicos</ListItem>
                    <ListItem>Atualização de Dados Cadastrais - SEDE</ListItem>
                    <ListItem>Levantamento de Status Vacinal</ListItem>
                  </UnorderedList>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </VStack>
      </NoteContainer>
    </ExclusiveContainer>
  )
}
